module.exports = __webpack_public_path__ + "static/homepage-mobile-mediaingenuity-bd3e5694f7978e51147cb721d09eb71c.jpg";